// src/component/ui/Buttons.jsx

import React from 'react';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/material/styles';

/**
 * Premium Gold Gradient button styling with shimmer transition
 */
const GoldGradientButton = styled(Button)(({ theme }) => ({
  background: 'linear-gradient(135deg, #D97706 0%, #B45309 100%)',
  color: '#FFFFFF',
  border: 'none',
  boxShadow: '0 4px 10px rgba(217, 119, 6, 0.25)',
  '&:hover': {
    background: 'linear-gradient(135deg, #F59E0B 0%, #D97706 100%)',
    boxShadow: '0 6px 16px rgba(217, 119, 6, 0.40)',
  },
  '&:disabled': {
    background: 'linear-gradient(135deg, #E2E8F0 0%, #CBD5E1 100%)',
    color: '#94A3B8',
  }
}));

/**
 * PrimaryButton - Standard contained action button
 * @param {Object} props
 * @param {React.ReactNode} props.children - Label or content
 * @param {boolean} [props.loading=false] - Display a progress spinner
 * @param {boolean} [props.premium=false] - Toggle gold premium gradient theme
 * @param {Object} [props.rest] - standard MUI Button props
 */
export const PrimaryButton = ({ children, loading = false, premium = false, ...rest }) => {
  if (premium) {
    return (
      <GoldGradientButton
        disabled={loading || rest.disabled}
        {...rest}
      >
        {loading ? <CircularProgress size={20} color="inherit" /> : children}
      </GoldGradientButton>
    );
  }

  return (
    <Button
      variant="contained"
      color="primary"
      disabled={loading || rest.disabled}
      {...rest}
    >
      {loading ? <CircularProgress size={20} color="inherit" /> : children}
    </Button>
  );
};

/**
 * SecondaryButton - Standard outlined action button
 * @param {Object} props
 * @param {React.ReactNode} props.children - Label or content
 * @param {boolean} [props.loading=false] - Display a progress spinner
 * @param {Object} [props.rest] - standard MUI Button props
 */
export const SecondaryButton = ({ children, loading = false, ...rest }) => {
  return (
    <Button
      variant="outlined"
      color="primary"
      disabled={loading || rest.disabled}
      {...rest}
    >
      {loading ? <CircularProgress size={20} color="primary" /> : children}
    </Button>
  );
};
const buttonExports = { PrimaryButton, SecondaryButton };
export default buttonExports;
